import React, { useContext } from 'react';
import { useBootstrapLD } from '../../hooks/useBootstrapLD';
import ProspectHeader from './ProspectHeader';
import { Banner } from '../Banners/Banner';
import { ProspectNavContext } from '../../context/ProspectNavContext';
import NavToast from '../Toast/NavToast';
import MobileWebBanner from '../MobileWebBanner';

const ProspectGlobalNavContent = () => {
  const {
    env,
    mainProps: { isPublicShop },
  } = useContext(ProspectNavContext);
  const { flag: ccToastNotification } = useBootstrapLD(
    env,
    'cc-toast-notification',
  );

  return (
    <>
      <MobileWebBanner />
      <Banner isPublicShop={isPublicShop} />
      <ProspectHeader />
      {ccToastNotification && <NavToast />}
    </>
  );
};

export default ProspectGlobalNavContent;
